import createVueApp from '@phoenix/createVueApp';
import FormModal from '@maison/components/form/FormModal.vue';

document.querySelectorAll('.phoenix-form-modal').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('FormModal', FormModal);
  app.mount(el);
});
